import React, { Component } from 'react';
import socketIOClient from 'socket.io-client';
import config from '../../config';

class LocalizationPage extends Component {
  constructor() {
    super();

    this.state = {
      input: '',
      message: [],
      endpoint: `${config.api.url}`,
    };
  }

  componentDidMount = () => {
    this.response();
  };

  send = (message) => {
    // const { endpoint, input } = this.state
    // const socket = socketIOClient(endpoint)
    // socket.emit('sent-message', input)
    // this.setState({ input: '' })
  };

  response = () => {
    const { endpoint, message } = this.state;
    const temp = message;
    const socket = socketIOClient(endpoint);
    socket.on(`localization`, (messageNew) => {
      temp.unshift(messageNew);
      this.setState({ message: temp });
    });
  };

  changeInput = (e) => {
    this.setState({ input: e.target.value });
  };

  render() {
    // const { input, message } = this.state
    const { message } = this.state;
    return (
      <div>
        {/* <div style={style}>
          <input value={input} onChange={this.changeInput} />
          <button onClick={() => this.send()}>Send</button>
        </div> */}
        {message.map((data, i) => (
          <div key={i} style={style}>
            {JSON.stringify(data.data[0])}
          </div>
        ))}
      </div>
    );
  }
}

const style = { marginTop: 20, paddingLeft: 50 };

export default LocalizationPage;
